// src/api.js

const BASE_URL = 'https://backendapi-99.lixrinnovation.com'; //main production link
// const BASE_URL = 'http://localhost:5000';

export default BASE_URL;
